module.exports = __webpack_public_path__ + "img/twitter-white.73f2adc9.png";